import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { getRuns, updateRun, deleteRun, reprocessRuns } from '../api/runs';

import { getConfig } from '../api/configs';

export const useRuns = (queryString: string = '') =>
  useQuery({
    queryKey: ['runs', queryString],
    queryFn: () => getRuns(queryString),
  });

export const useRunAndCalibration = (runId: string) =>
  useQuery({
    queryKey: ['runAndCalibration', runId],
    queryFn: async () => {
      const run = await getRuns(`scope=grid_data&id=${runId}`).then((data) => data[0]);
      const calibration = run.config_id ? await getConfig(run.config_id) : null;
      return { run, calibration };
    },
  });

export const useUpdateRun = () =>
  useMutation({
    mutationFn: (data: any) => updateRun(data.runId, data),
  });

export const useDeleteRun = (runId: string) =>
  useMutation({
    mutationFn: () => deleteRun(runId),
  });

export const useReprocessRuns = () => useMutation({ mutationFn: reprocessRuns });

export const useInvalidateRuns = (queryString: string = '') => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ['runs', queryString] });
  };
};
